import { FaultLevel, GlobalTimeRange } from '@customer/store/slices/globalSlice';
import Metric, { MetricSize } from '../metric/Metric';
import PercentageBar from '@customer/components/charts/percentage-bar/PercentageBar';
import styles from './FaultLevelInsight.module.scss';
import { useTranslation } from 'react-i18next';
import { ChartColorScheme } from '@customer/components/charts/config';
import { calcPercentage } from '@cas/utils/numberHelpers';
import { useLocaleFormatter } from '@customer/shared/hooks/useLocaleFormatter';

export const getFaultChartColorScheme = (faultLevel: FaultLevel): ChartColorScheme => {
  switch (faultLevel) {
    case FaultLevel.One:
      return ChartColorScheme.RedGrey;
    case FaultLevel.Two:
      return ChartColorScheme.OrangeGrey;
    case FaultLevel.Three:
      return ChartColorScheme.YellowGrey;
  }
};

interface FaultLevelInsightProps {
  faultLevel: FaultLevel;
  timeRange: GlobalTimeRange;
  totalFaults?: number;
  activeFaults?: number;
  duration?: number;
  ign?: number;
}

export const FaultLevelInsight = ({
  faultLevel,
  timeRange,
  totalFaults,
  activeFaults,
  duration,
  ign,
}: FaultLevelInsightProps) => {
  const { t } = useTranslation();
  const { getTimeRangeText } = useLocaleFormatter();

  const percentage: number =
    typeof duration === 'number' && typeof ign === 'number' ? calcPercentage(duration, ign) : 0;

  return (
    <section className={styles.container}>
      <div className={styles.percentage}>
        <div className={styles.label}>{t('PercentageTimeInLevelFault', { level: faultLevel })}</div>
        <PercentageBar percentage={percentage} colorScheme={getFaultChartColorScheme(faultLevel)} />
      </div>

      <div className={styles.metrics}>
        <Metric
          label={
            <>
              {getTimeRangeText(timeRange, t)}
              <br />
              {t('TotalFaults')}
            </>
          }
          dataPrimary={totalFaults}
          size={MetricSize.M}
        />
        <Metric label={t('CurrentlyActiveFaults')} dataPrimary={activeFaults} size={MetricSize.M} />
      </div>
    </section>
  );
};

export default FaultLevelInsight;
